// Debouncer function, mostly used for form submission see ECLParameters, ECLForm
export default function debounce(func, timeout = 2000) {
   let timer;
   return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
         func.apply(this, args);
      }, timeout);
   };
}
